import {
  ROOT,
  GET_ALL_ROOMS_INFO,
  ADD_NEW_ROOW,
  UPDATE_ROOM,
  DUPLICATE_ROOM,
  DELETE_ROOM,
  GET_ROOM_DETAIL,
  GET_ROOM_VIEW,
  GET_BED_TYPE,
  GET_ROOM_AMENITIES,
  UPDATE_ROOM_AMENITIES,
  GET_ROOM_IMAGE,
  UPDATE_ROOM_IMAGE,
  GET_ROOM_TYPE
} from "@/_helpers/constant.js";
import { requestOptions, handleResponse } from "@/_helpers";

//#region list of rooms
function getAllRooms() {
  return fetch(ROOT + GET_ALL_ROOMS_INFO, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function getRoomType(lang) {
  return fetch(ROOT + GET_ROOM_TYPE + `?lang=${lang}`, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function createRoom(data) {
  return fetch(ROOT + ADD_NEW_ROOW, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function updateRoom(data) {
  return fetch(ROOT + UPDATE_ROOM, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function duplicateRoom(data) {
  return fetch(ROOT + DUPLICATE_ROOM, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function removeRoom(id) {
  return fetch(ROOT + DELETE_ROOM + `/${id}`, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
//#endregion

//#region room detail
function getRoomDetail(id) {
  return fetch(ROOT + GET_ROOM_DETAIL + `/${id}`, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function getRoomView() {
  return fetch(ROOT + GET_ROOM_VIEW, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function getBedType() {
  return fetch(ROOT + GET_BED_TYPE, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
//#endregion

//#region room amenities
function getRoomAmenities(id) {
  return fetch(ROOT + GET_ROOM_AMENITIES, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function updateRoomAmenities(id, data) {
  return fetch(
    ROOT + UPDATE_ROOM_AMENITIES + `/${id}`,
    requestOptions.post(data)
  )
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
//#endregion

//#region room images
function getRoomImages(id) {
  return fetch(ROOT + GET_ROOM_IMAGE + `/${id}`, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function updateRoomImages(id, data) {
  return fetch(ROOT + UPDATE_ROOM_IMAGE + `/${id}`, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
//#endregion
export const service = {
  getAllRooms,
  createRoom,
  updateRoom,
  duplicateRoom,
  removeRoom,
  getRoomDetail,
  getRoomView,
  getBedType,
  getRoomAmenities,
  updateRoomAmenities,
  getRoomImages,
  updateRoomImages,
  getRoomType
};
